<svg width="80" height="80" viewBox="0 0 80 80">
  <circle class="progress-ring-back-circle" r="35" cx="40" cy="40"></circle>
  <circle class="progress-ring-front-circle" r="35" cx="40" cy="40"
          [attr.stroke-dasharray]="(2 * 3.14 * 35)"
          [attr.stroke-dashoffset]="(2 * 3.14 * 35 * ((100 - progress) / 100))"></circle>
  <text class="progress-ring-text" x="50%" y="50%" text-anchor="middle" dominant-baseline="middle">{{text}}</text>
</svg>
